import type { HrisImportEmployeeChangeLog } from '../../typescript-types/hris-import-employee-change-log';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { hrisImportEmployeeChangeLogsStateForHrisImportLogIdSelector } from '../../hris-import-log/hris-import-log-selectors';

import { get } from '../../api/api';

export const loadHrisImportEmployeeChangeLogs = (hrisImportLogId: number) =>
  createGenericDispatcher<Array<HrisImportEmployeeChangeLog>>({
    name: 'LOAD_HRIS_IMPORT_EMPLOYEE_CHANGE_LOGS',
    loadFunction: () => get(`/hris-import-log/${hrisImportLogId}/employee-change-logs`),
    args: { hrisImportLogId },
    shouldExecuteSelector: (state: any) =>
      hrisImportEmployeeChangeLogsStateForHrisImportLogIdSelector(state, hrisImportLogId),
  });
